import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Popover } from 'antd';

/** Stylesheet Imports */
import './AccountMenu.scss';
import { faChevronRight, faUser } from '@fortawesome/pro-light-svg-icons';

export interface Props {
  className?: string;
  content: React.ReactNode;
  userName: string;
  orgName: string;
  onClick?: () => void;
  visible: boolean;
}

export default class AccountMenu extends React.Component<Props> {
  render() {
    const { className, content, onClick, userName, orgName, visible } = this.props;
    const classes = classNames('account-menu', className);
    return (
      <Popover placement="rightBottom" content={content} trigger="click" open={visible}>
        <div className={classes} onClick={onClick}>
          <div className="account-menu__avatar gigg-menu__icon">
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div className="account-menu__info">
            <div className="account-menu__username">{userName}</div>
            <div className="account-menu__org">{orgName}</div>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="account-menu__arrow" />
        </div>
      </Popover>
    );
  }
}
